/** Chrome dictionary: English-as-key → Czech (V1). Content text uses LocalizedText, not this. */
export const csCZ: Record<string, string> = {
  'Start test': 'Spustit test',
  'Session expires in {time}': 'Sezení vyprší za {time}',
  'Your training': 'Vaše školení',
  'All done': 'Vše hotovo',
  'Return to FixIt': 'Zpět do FixIt',
  Continue: 'Pokračovat',
  'Next chapter': 'Další kapitola',
  Locked: 'Uzamčeno',
  Done: 'Hotovo',
  'In progress': 'Probíhá',
  'Final test': 'Závěrečný test',
  'Submit answers': 'Odeslat odpovědi',
  'I confirm that I have completed this training in full and understood its content.':
    'Prohlašuji, že jsem toto školení absolvoval(a) v plném rozsahu a porozuměl(a) jeho obsahu.',
  'You passed': 'Prošli jste',
  'Not passed yet': 'Zatím neúspěšně',
  'Score: {score}%': 'Výsledek: {score} %',
  'Review chapters': 'Projít znovu kapitoly',
  'Retake the test': 'Opakovat test',
  'Areas to review': 'Oblasti k zopakování',
  'Session expired': 'Sezení vypršelo',
  'Return to FixIt to continue': 'Vraťte se do FixIt a pokračujte',
  'Your training session could not be accepted. Restart the training and complete each chapter again.':
    'Průběh školení se nepodařilo ověřit. Spusťte školení znovu a projděte znovu každou kapitolu.',
  'Your answers could not be submitted. Try submitting them again.':
    'Odpovědi se nepodařilo odeslat. Zkuste je odeslat znovu.',
  'Training could not be restarted. Try again.':
    'Školení se nepodařilo spustit znovu. Zkuste to ještě jednou.',
  'Retry chapter': 'Zkusit kapitolu znovu',
  'Training progress could not be saved. Retry this chapter.':
    'Průběh školení se nepodařilo uložit. Zkuste tuto kapitolu znovu.',
  'Restart training': 'Spustit školení znovu',
  'This link is invalid or expired': 'Tento odkaz je neplatný nebo vypršel',
  'Loading…': 'Načítání…',
  'Training not available': 'Školení není dostupné',
  'Required trainings': 'Požadovaná školení',
  Valid: 'Platné',
  Needed: 'Potřebné',
  Expired: 'Vypršelé',
  // - added in the 2026-06-24 editorial UI pass -
  'Safety training': 'Školení BOZP',
  'Complete the required trainings below.': 'Dokončete níže uvedená povinná školení.',
  'Everything is complete.': 'Vše je dokončeno.',
  Chapter: 'Kapitola',
  Contents: 'Obsah',
  Close: 'Zavřít',
  'Sections: {count}': 'Sekcí: {count}',
  'Keep reading to continue': 'Pokračujte ve čtení až do konce kapitoly',
  'Take your time with this chapter': 'Věnujte této kapitole ještě chvíli',
  // Unit abbreviation, not a counted noun - sidesteps Czech plural forms at 1/2-4/5+.
  '{seconds} s left': 'Ještě {seconds} s',
  'Complete the activities in this chapter': 'Dokončete aktivity v této kapitole',
  'A moment more · {seconds} s': 'Ještě chvíli · {seconds} s',
  'Continue to the test': 'Pokračovat na test',
  'Question {number} of {total}': 'Otázka {number} z {total}',
  'Select all correct answers': 'Vyberte všechny správné odpovědi',
  'Back to overview': 'Zpět na přehled',
  Back: 'Zpět',
  'Well done, this training is complete.': 'Výborně, školení je dokončeno.',
  'Review the chapters and try the test again.': 'Projděte si kapitoly a zkuste test znovu.',
  Progress: 'Postup',
  'Preparing your training…': 'Připravujeme školení…',
  // - fixit/4329: a session that did not open is retryable -
  'Training could not be opened. Check your connection and try again.':
    'Školení se nepodařilo otevřít. Zkontrolujte připojení a zkuste to znovu.',
  'Try again': 'Zkusit znovu',
  // - theory-only banner (external qualification profiles) -
  'Theory course': 'Teoretický kurz',
  'This course covers the theory. The professional qualification for this work is proven by a separate external exam.':
    'Tento kurz pokrývá teorii. Odborná způsobilost pro tuto práci se prokazuje samostatnou externí zkouškou.',
};
